import $ from 'jquery';
import 'magnific-popup';
import attachEnterAsClick from 'utils/attachEnterAsClick';
import BROCHURE_EMAIL_KEY from 'consts/storage-keys';

// Programatically click the auto open modal links
function attachAutoOpenModals() {
    const $modalLinks = $('.js-open-modal.js-auto-open');
    if (!$modalLinks.length) { return; }

    $modalLinks.click();
}

// Add event to a js close modal item to close the target modal
function attachCloseModalBtn(elementId) {
    const $closeModal = $(elementId).find('.js-close-modal');
    if (!$closeModal.length) { return; }

    $closeModal.click(e => {
        e.preventDefault();
        $closeModal.magnificPopup('close');
    });
    attachEnterAsClick($closeModal);
}

// Move the close X to top of the container for accessibility purpose
function attachCloseCrossKeyEvent(elementId) {
    const $closeModal = $(elementId).find('.mfp-close');
    if (!$closeModal.length) { return; }

    attachEnterAsClick($closeModal);
}

// Export this create magnificPopup function so it can be used by other scrxipts
export default function createMagnificPopup(element) {
    const targetId = $(element).attr('href');
    $(element).magnificPopup({
        type: 'inline',
        removalDelay: 500, // delay removal by X to allow out-animation
        midClick: true,
        mainClass: $(element).data('mfp-class') ? $(element).data('mfp-class') : 'mfp-fade-modal',
        fixedContentPos: true,
        callbacks: {
            open() {
                attachCloseModalBtn(targetId);
                attachCloseCrossKeyEvent(targetId);
            }
        }
    });
}

// Init the modal open links
function attachModalLinks() {
    const $modalLinks = $('.js-open-modal');
    if (!$modalLinks.length) { return; }

    $modalLinks.each(function () {
        createMagnificPopup(this);
    });
}

// Init the popup open links
function attachConfirmModalLinks() {
    const $modalLinks = $('.js-accept-decline-magnific-modal');
    if (!$modalLinks.length) { return; }

    $modalLinks.each(function () {
        createConfirmMagnificPopup(this);
    });
}

// With a accept / decline popup, the decline btn should close the popup while the accept should trigger
// the orginial function of the calling link / button
export function createConfirmMagnificPopup(element, src = null, appearConditionFunction = null) {
    $(element).click(function (e) {
        const targetId = src ? src : $(element).data('mfp-src');
        const hasAccepted = $(this).data('mfp-accepted');
        const caller = this;
        if (!hasAccepted && (!appearConditionFunction || appearConditionFunction())) {
            e.preventDefault();
            $.magnificPopup.open({
                items: {
                    src: targetId,
                    type: 'inline'
                },
                removalDelay: 500, // delay removal by X to allow out-animation
                midClick: true,
                mainClass: $(element).data('mfp-class') ? $(element).data('mfp-class') : 'mfp-fade-modal',
                fixedContentPos: true,
                callbacks: {
                    open: () => {
                        attachCloseModalBtn(targetId);
                        moveCloseCrossToTop(targetId);
                        attachConfirmButton(targetId, caller);
                    },
                    beforeOpen: () => { $('html').addClass('mfp-scroll-fix'); },
                    close: () => { $('html').removeClass('mfp-scroll-fix'); }
                }
            });
        }
    });
}

function attachConfirmButton(elementId, caller) {
    const $acceptBtn = $(elementId).find('.js-accept');
    const $declineBtn = $(elementId).find('.js-decline');
    if (!$acceptBtn.length || !$declineBtn.length) { return; }

    // On accept btn click, set the caller link's accepted status to true (to bypass popup opening call)
    // and then Programatically click it
    $acceptBtn.on('click', e => {
        e.preventDefault();
        $(caller).data('mfp-accepted', 'true');

        if ($(caller).is('a')) {
            window.location = $(caller).attr('href');
        } else {
            $(caller).click();
        }
    });

    // Simply close the popup with decline click
    $declineBtn.on('click', e => {
        e.preventDefault();
        $.magnificPopup.close();
    });
}

// Move the close X to top of the container for accessibility purpose
function moveCloseCrossToTop(elementId) {
    const $closePopup = $(elementId).find('.mfp-close');
    if (!$closePopup.length) { return; }

    $closePopup.prependTo($closePopup.parent());
    attachEnterAsClick($closePopup);
}

const BROCHURE_EMAIL_PLACEHOLDER = '%user_email%';

// Put the address c-form-tracker.js stored on submit in place of the CMS's %user_email%
// placeholder, then remove it so it's only used once. Without one (storage blocked, another
// tab), the placeholder is removed so it never shows.
function fillBrochureEmail(modal) {
    const content = modal.querySelector('.modal-content .modal-primary-content');
    if (!modal.classList.contains('brochure-modal') || !content) { return; }

    let email = '';
    try {
        email = sessionStorage.getItem(BROCHURE_EMAIL_KEY) || '';
        sessionStorage.removeItem(BROCHURE_EMAIL_KEY);
    } catch (error) {
        email = '';
    }

    // Replace inside text nodes only, so the CMS markup around it stays. Setting nodeValue, not
    // HTML, means a crafted address can't inject markup.
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        if (node.nodeValue.includes(BROCHURE_EMAIL_PLACEHOLDER)) {
            node.nodeValue = node.nodeValue.split(BROCHURE_EMAIL_PLACEHOLDER).join(email);
        }
    }
}

// Open modals triggered by URL query parameters via data-params-trigger attribute
function openModalFromParams() {
    const params = new URLSearchParams(window.location.search);
    if (!params.toString()) { return; }

    const $modals = $('[data-params-trigger]');
    if (!$modals.length) { return; }

    $modals.each(function () {
        const triggerParam = $(this).data('params-trigger');
        if (!triggerParam) { return; }

        // Check if the URL contains the exact param (e.g. ?success-modal=true)
        if (params.get(triggerParam) !== null && params.get(triggerParam) === 'true') {
            const modalId = `#${$(this).attr('id')}`;
            fillBrochureEmail(this);

            $.magnificPopup.open({
                items: {
                    src: modalId,
                    type: 'inline'
                },
                removalDelay: 500,
                midClick: true,
                mainClass: 'mfp-fade-modal',
                fixedContentPos: true,
                callbacks: {
                    open: () => {
                        attachCloseModalBtn(modalId);
                        attachCloseCrossKeyEvent(modalId);
                    }
                }
            });

            // Remove the trigger param from the URL without a page reload
            params.delete(triggerParam);
            const newUrl = params.toString()
                ? `${window.location.pathname}?${params.toString()}`
                : window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }
    });
}

// Run the functions on document ready
$(() => {
    attachModalLinks();
    attachAutoOpenModals();
    attachConfirmModalLinks();
    openModalFromParams();
});
